// src/types/navigation.ts

export type ViewId =
  | 'sanctuary'
  | 'treatises'
  | 'archive'
  | 'anvil'
  | 'oracle'
  | 'forge'
  | 'fortress';

export interface NavItem {
  id: ViewId;
  label: string;
  latinSubtitle: string;
  iconName: string;
}

export const NAV_ITEMS: NavItem[] = [
  { id: 'sanctuary', label: 'Sanctuary', latinSubtitle: 'Sedes Regni', iconName: 'Crown' },
  { id: 'treatises', label: 'Treatises', latinSubtitle: 'Gnosis Chthonia', iconName: 'Scroll' },
  { id: 'anvil', label: 'Anvil of Solomon', latinSubtitle: 'Incudo Numerorum', iconName: 'Hammer' },
  { id: 'oracle', label: 'Brass Vessel', latinSubtitle: 'Vas Oraculi', iconName: 'Compass' },
  { id: 'forge', label: 'Living Forge', latinSubtitle: 'Camīnus Ferri', iconName: 'Flame' },
  { id: 'fortress', label: 'Fortress Gate', latinSubtitle: 'Porta Indomita', iconName: 'Shield' },
];
